module.exports = __webpack_public_path__ + "img/V1.f65863ac.jpg";